module.exports = "mat-tab-group {\n  margin-top: -3rem;\n  height: 70vh;\n}\n\nmat-tab-header {\n  position: fixed;\n  top: 0;\n}\n\nmat-nav-list {\n  position:fixed;\n  bottom: 0;\n}\n\nmat-radio-group {\n  margin: auto;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/matriz/matriz.component.css
// module id = ./src/app/matriz/matriz.component.css
// module chunks = main